// Project category constants
export const CATEGORIES = {
  BRAND_IDENTITY: "Brand Identity",
  DIGITAL_DESIGN: "Digital Design", 
  ENVIRONMENTAL_SIGNAGE: "Environmental Signage"
};

// Export individual constants for convenience
export const BRAND_IDENTITY = CATEGORIES.BRAND_IDENTITY;
export const DIGITAL_DESIGN = CATEGORIES.DIGITAL_DESIGN;
export const ENVIRONMENTAL_SIGNAGE = CATEGORIES.ENVIRONMENTAL_SIGNAGE; 